import PropTypes from 'prop-types'
import { Spinner } from 'reactstrap'

import {
  StyledButton,
  StyledSecondButton,
  StyledModal,
  StyledModalHeader,
  StyledModalBody,
  StyledModalFooter,
  StyledModalImage,
} from './styles'

const CustomModal = ({
  isOpen,
  toggle = () => {},
  buttonLabel = undefined,
  message = '',
  title = '',
  secondButtonLabel = undefined,
  secondButtonAction = undefined,
  mode = '',
  showClose = true,
  headerImage = '',
  isProcessing = null,
}) => (
  <div>
    <StyledModal isOpen={isOpen} toggle={toggle} mode={mode} centered>
      <StyledModalHeader toggle={showClose ? toggle : null} mode={mode}>
        {headerImage && <StyledModalImage src={headerImage} mode={mode} />}
        <span>{title}</span>
      </StyledModalHeader>
      <StyledModalBody mode={mode}>{message}</StyledModalBody>
      <StyledModalFooter mode={mode}>
        {buttonLabel && (
          <StyledButton color="secondary" onClick={toggle} disabled={isProcessing} mode={mode}>
            {buttonLabel}
          </StyledButton>
        )}
        {secondButtonLabel && (
          <StyledSecondButton color="secondary" onClick={secondButtonAction} disabled={isProcessing} mode={mode}>
            {isProcessing ? <Spinner /> : secondButtonLabel}
          </StyledSecondButton>
        )}
      </StyledModalFooter>
    </StyledModal>
  </div>
)

CustomModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func,
  buttonLabel: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  title: PropTypes.string,
  secondButtonLabel: PropTypes.string,
  secondButtonAction: PropTypes.func,
  mode: PropTypes.string,
  showClose: PropTypes.bool,
  headerImage: PropTypes.string,
  isProcessing: PropTypes.bool,
}

export default CustomModal
